// Navigation
import { t } from "../texts.js";

// Desktop navigation
// Sticky
let DestopNavigation = document.querySelector('.navigation-desktop');
let menuMobileContainer = document.querySelector('.navigation-mobile');

if (DestopNavigation) {
    window.addEventListener('scroll', function () {
        DestopNavigation.classList.toggle('navigation-desktop--sticky', window.scrollY > 0);
    });
}

if (menuMobileContainer) {
    window.addEventListener('scroll', function () {
        menuMobileContainer.classList.toggle('navigation-mobile--sticky', window.scrollY > 0);
    });
}

// Elements
let menu = document.querySelector('.menu');
let menuIconButton = document.querySelector('.js-open-menu');

// Sub menu
let mainMenu = document.querySelector('.menu__body-main');
let subMenu = document.querySelector('.menu__body-sub');
let subMenuButtons = document.querySelectorAll('.menu__sub-button-open');
let findSubMenu = document.querySelectorAll('.menu__sub-group');
let closeSubButton = document.querySelector('.menu__sub-button-close');

// Main menu
if (menu) {
    menuIconButton.addEventListener('click', (e) => {
        if (!e.currentTarget.classList.contains('open')) {
            // document.body.classList.add('body-hidden')
            menu.classList.add('open');
            menuMobileContainer.classList.add('open');
            closeAllSubGroup();
        } else {
            closeSubButton.classList.remove('show');
        }
    });
}

if (subMenuButtons.length > 0) {
    // Sub menu
    subMenuButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            closeAllSubGroup();
            mainMenu.classList.add('hide');
            closeSubButton.classList.add('show');
            // Back sits where the search icon is: the icon steps aside while a submenu is open
            menuMobileContainer.classList.add('sub-open');

            setTimeout(() => {
                subMenu.classList.add('show');
            }, 100);

            findSubMenu[e.currentTarget.dataset.subOpen].classList.add('show');
        });
    });

    closeSubButton.addEventListener('click', (e) => {
        closeAllSubGroup();
    });
}

// Functions
let closeAllSubGroup = () => {
    menuMobileContainer.classList.remove('sub-open');
    findSubMenu.forEach((e) => {
        e.classList.remove('show');
        mainMenu.classList.remove('hide');
        subMenu.classList.remove('show');
        closeSubButton.classList.remove('show');
    });
};

let lastWindowWidth = window.innerWidth;

window.addEventListener('resize', () => {
    if (window.innerWidth === lastWindowWidth) {
        return;
    }
    lastWindowWidth = window.innerWidth;

    try {
        document.querySelector('.js-open-menu').classList.remove('open');
        document.querySelector('.menu-icon__text').textContent = t('Menu');
        document.querySelector('.navigation-mobile ').classList.remove('open');
    } catch (err) {
        console.log(err);
    }

    if (document.querySelector('.filter')) {
        document.querySelector('.filter').classList.remove('open');
    }
});
